var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"p-content-plan-manual-trend-keywords__item"},[_c('EllipsisTip',[_vm._v(_vm._s(_vm.keyword.word))]),_c('div',{staticClass:"p-contentplans-graph__bar",style:({ width: _vm.barW + '%' }),attrs:{"data-count":_vm.keyword.count}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }